import React from 'react';
import { format, addMonths, subMonths } from 'date-fns';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiChevronLeft, FiChevronRight } = FiIcons;

const CalendarHeader = ({ currentMonth, onMonthChange }) => {
  return (
    <div className="flex items-center justify-between px-6 py-4 border-b border-gray-700/50">
      <h2 className="text-xl font-bold text-white">
        {format(currentMonth, 'MMMM yyyy')}
      </h2>
      <div className="flex items-center space-x-2">
        <button
          onClick={() => onMonthChange(subMonths(currentMonth, 1))}
          className="p-2 hover:bg-gray-700/50 rounded-full text-gray-400 hover:text-white transition-colors"
        >
          <SafeIcon icon={FiChevronLeft} className="text-xl" />
        </button>
        <button
          onClick={() => onMonthChange(addMonths(currentMonth, 1))}
          className="p-2 hover:bg-gray-700/50 rounded-full text-gray-400 hover:text-white transition-colors"
        >
          <SafeIcon icon={FiChevronRight} className="text-xl" />
        </button>
      </div>
    </div>
  );
};

export default CalendarHeader;